












import { defineComponent } from "@vue/composition-api";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import providers from "@/lib/api";
import SelectTagsView from "@/components/SelectTagsView";

export default defineComponent({
  name: "DiscoveryFilterTagsController",
  components: { SelectTagsView },
  props: {
    selectedTags: { type: Array as () => string[], required: true },
  },
  data() {
    return {
      loading: false,
      tags: [] as TagInfo[],
    };
  },
  methods: {
    async getData() {
      this.tags = await providers.TagsProvider.findAll();
    },
    onSave(tags: string[], cb: Function) {
      this.$emit("select", tags);
      cb();
    },
  },
  created() {
    this.getData();
  },
});
